import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-modal-multa-ncpc',
    templateUrl: './modal-multa-ncpc.component.html',
    styleUrls: ['./modal-multa-ncpc.component.scss']
})
export class ModalMultaNcpcComponent implements OnInit {

    public multaArtNCP: FormGroup;
    public modalRef: NgbModalRef; 

    constructor() { }

    ngOnInit(): void {
    }

    dismiss() {
        this.modalRef.dismiss();
    }

    close() {
        this.modalRef.close();
    }
}
